// extracted by mini-css-extract-plugin
module.exports = {"root":"Column_root__HI3Dk","header":"Column_header__3V1Ov","title":"Column_title__i_hFp"};